'use client';

import styled from 'styled-components';

import { Skeleton } from '@zoomit/primitives';

import type { BannerSpec } from '../../types/modules';

type DisplayProps = {
  bannerSpec: BannerSpec;
  hasBorderRadius: boolean;
};

const DisplaySkeleton = (props: DisplayProps) => {
  const {
    bannerSpec: { maxWidth, maxHeight },
    hasBorderRadius,
  } = props;

  return (
    <DisplayRoot $maxWidth={maxWidth} $maxHeight={maxHeight}>
      <Skeleton width="100%" height="100%" className={hasBorderRadius ? 'rounded-sm' : 'rounded-none'} />
    </DisplayRoot>
  );
};

export default DisplaySkeleton;

const DisplayRoot = styled.div<{ $maxWidth: number; $maxHeight: number }>`
  width: 100%;
  aspect-ratio: ${({ $maxWidth, $maxHeight }) => $maxWidth / $maxHeight};
`;
